import {
  FormField,
  SfAmountInputFormField,
  SfInputFormField,
} from 'ngx-smart-form';
import { BudgetDetails } from 'src/interfaces/budget-details';

export const getBudgetDataFields = (
  budgetData: BudgetDetails | undefined,
  key: string
) => {
  const fields: FormField<BudgetDetails>[][] = [
    [
      new SfAmountInputFormField({
        formControlName: 'current',
        label: budgetData?.annoCorrente || 'Anno corrente',
        currency: '€',
        required: true,
      }),
      new SfAmountInputFormField({
        formControlName: 'previus',
        label: budgetData?.annoPrecedente || 'Anno precedente',
        currency: '€',
        required: key === 'valoreProduzione',
        value: budgetData?.previus || 0,
      }),
      new SfInputFormField({
        formControlName: 'note',
        label: 'Note',
      }),
    ],
  ];

  fields.forEach((row) =>
    row.forEach(
      (field) =>
        (field.value =
          field.value !== undefined
            ? field.value
            : budgetData?.[field.formControlName])
    )
  );

  return fields;
};
